// test288
(288 && 0);
